export const COLORS = {
PRIMARY :"#7B408C",
PRIMARY_DARK :"#2E1834",
WHITE : "#F7F9F9",
DISABLED:"#B89BC3",
TEXT_BLACK:"#333333",
BLACK:"#000000",
TEXT_GREY:"#9097a3",
BORDER_GREY : "#edf0f2",
DANGER:"#FF3347"
}